import { ENVIRONMENT_TYPE } from "../constant/common";
import { environment } from "../constant/environment";
import { decryptData, encryptData } from "../utils/api/encryption";
import { consoleLog } from "../utils/consoleLog/consoleLog";

export const setItemInSessionStorage = (key: string, value: any) => {
  try {
    if (environment === ENVIRONMENT_TYPE.LOCAL) {
      const serializedValue = JSON.stringify(value);
      sessionStorage.setItem(key, serializedValue);
    } else {
      const encryptedValue = encryptData(value);
      sessionStorage.setItem(key, encryptedValue);
    }
  } catch (error) {
    consoleLog(`Failed to store item in sessionStorage: ${error}`);
  }
};

export const getItemFromSessionStorage = (key: string) => {
  try {
    const serializedValue = sessionStorage.getItem(key);
    if (serializedValue === null) {
      return null;
    }
    if (environment === ENVIRONMENT_TYPE.LOCAL) {
      return JSON.parse(serializedValue);
    } else {
      const decryptedData = decryptData(serializedValue);
      return decryptedData;
    }
  } catch (error) {
    consoleLog(`Failed to retrieve item from sessionStorage: ${error}`);
    return null;
  }
};
